import Icon from "../Icon";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import '../../../assets/sass/components/forms/error-area.scss';

const ErrorArea = ({message}) => {
    return (
        <div className="error-area">
            <Icon className="error-area--icon" icon={faExclamationCircle}/>
            <div className="error-area--text"> {message} </div>
        </div>
    );
};

export default ErrorArea;
